/**
 * @generated SignedSource<<afb5a71f607452e6ccfac34da809c1f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab$data = {
  readonly browseLink: {
    readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
  };
  readonly contentCreatorAttribution: {
    readonly __typename: "StoryTellingModuleCreator";
  } | null;
  readonly contentHeader: string | null;
  readonly tabType: string;
  readonly " $fragmentType": "PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab";
};
export type PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab$key = {
  readonly " $data"?: PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "browseLink",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tabType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentHeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModuleCreator",
      "kind": "LinkedField",
      "name": "contentCreatorAttribution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoryTellingTab",
  "abstractKey": null
};

(node as any).hash = "fd3bda61ec2c2a4042af2803e44f4bfa";

export default node;
